import styled from "styled-components";
import ArrowRight from "../images/arrow_right.png";
import GlobalFonts from "../fonts/fonts"
import "../fonts/font.css"	
import React from "react";

export const BasicButton = styled.button`
  height: ${(props) => props.height||70}px;
  width: ${(props) => props.width||620}px;
  margin-bottom : ${(props)=>props.marginBottom}px;
  position: relative;

  background: ${(props)=> props.color ||"#C7C7C7"};
  border : 0px;
  border-radius: 5px;
`;

const ButtonText = styled.div`
  position: absolute;
  width: 350px;
  height: 41px;
  left: 27px;
  top: 15px;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 41px;

  text-align: center;

  color: #ffffff;
`;

const FeeButtonText = styled.div`
  position : absolute;
  width: 145px;
  height: 25px;

  left : 15px;
  top: 15px;

  font-family: Noto Sans KR;
  font-weight: ${(props)=>props.fontWeight};
  font-style: normal;
  font-size: 16px;
  line-height: 26px;

  color: #FFFFFF;
`;

const FeeButtonImg = styled.img`
  position: absolute;
  width: 7px;
  height: 14px;
  left: 205px;
  top: 19px;
`;
FeeButtonImg.defaultProps = {
  src: ArrowRight,
};

const NextButtonText = styled.div`
position: absolute;
/* width: 171px;
height: 29px; */
/* left: calc(50% - 90px);
top: calc(50% - 13px); */

/* margin : 0px 10px; */
flex : none;

font-family: Noto Sans KR;
font-style: normal;
font-weight: 500;
font-size: ${(props)=>props.fontSize || 18}px;
line-height: ${(props)=>props.lineHeight || 27}px;

color: #FFFFFF;
`;

const ButtonImg = styled.img`
  position: absolute;
  width: 11px;
  height: 23px;
  left: 585px;
  top: 22px;
`;
ButtonImg.defaultProps = {
  src: ArrowRight,
};

const Btn = styled.button`
position: absolute;
width: 215px;
height: 45px;
right: calc(10% + 215px/2);
top: calc(50% - 45px/2);

display: flex;
align-items: center;
justify-content: center;

background: rgba(255, 255, 255, 0.2);
border: 1px solid #FFFFFF;
box-sizing: border-box;
border-radius: 50px;
`;

export const ButtonWithText = ({ text }) => (
  <BasicButton>
    <GlobalFonts/>
    <ButtonText> {text} </ButtonText>
  </BasicButton>
);

export const ButtonWithIcon = ({ height, width, marginBottom, text, color, onClick }) => (
  <BasicButton color={color} onClick={onClick} height={height} width={width} marginBottom={marginBottom}>
    <GlobalFonts/>
    <ButtonImg />
    <ButtonText> {text} </ButtonText>
  </BasicButton>
);

export const FeeButton = ({height, width, marginBottom, text, color, onFeeClick, fontWeight})=>(
  <BasicButton color={color} onClick={onFeeClick} height={height} width={width} marginBottom={marginBottom}>
    <GlobalFonts/>
    <FeeButtonImg />
    <FeeButtonText fontWeight={fontWeight}>{text}</FeeButtonText>
  </BasicButton>
);

export const NextButton =({onClick, text, href}) => (
  <Btn onClick={onClick} href={href}>
    <GlobalFonts/>
    <NextButtonText>{text}</NextButtonText>
  </Btn>
);